var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritesResposive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.36 0c-1.357 0-2.601.429-3.697 1.274-1.051.81-1.751 1.842-2.163 2.593-.412-.75-1.112-1.783-2.163-2.593C9.241.43 7.997 0 6.641 0 2.855 0 0 3.087 0 7.18c0 4.422 3.562 7.448 8.954 12.028.915.778 1.953 1.66 3.032 2.6a.782.782 0 0 0 1.028 0 307.84 307.84 0 0 1 3.033-2.6C21.438 14.628 25 11.602 25 7.18 25 3.087 22.145 0 18.36 0z",
    fill: "#F6B119",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesResposive);
export default __webpack_public_path__ + "static/media/favorites-resposive.aba7cb2e8e140d24206240897185f049.svg";
export { ForwardRef as ReactComponent };